import React from 'react';
import PillboxInput from '../../../../components/pillbox-input/PillboxInput';
import {checkPillboxTagError} from '../../error-checking/by-type/pillbox';

export default (props) => {
    const {
        key,
        value,
        forcedValue,
        values,
        data,
        rules,
        options,
        disabled,
        ruleRequired,
        isRequired,
        onChange
    } = props;

    return <PillboxInput
        value={forcedValue}
        defaultValue={value}
        prompt={options.prompt}
        onChange={onChange}
        duplicatable={rules.duplicatable}
        getTagErrors={tagValue => getPillboxTagErrors(tagValue, rules.eachTag, values)}
        clearable={true}
    />;
}

function getPillboxTagErrors(tagValue, rule, allValues) {
    const error = checkPillboxTagError(tagValue, rule, allValues);
    return error ? [error] : [];
}
